export enum RepintelSignalsEnum {
  VISITOR_INTEL = 'VISITOR_INTEL',
  BOMBORA_INTENT = 'BOMBORA_INTENT',
  PREDICTIVE_INTENT = 'PREDICTIVE_INTENT',
  NEW_LEADERSHIP = 'NEW_LEADERSHIP',
}
